<script>
  import landscapeModeler from "landscape-js-core/lib/Modeler";
  import "landscape-js-core/assets/landscape-js.css";

  import "bpmn-js-properties-panel/dist/assets/properties-panel.css";
  import "bpmn-js-properties-panel/dist/assets/element-templates.css";
  import {
    BpmnPropertiesPanelModule,
    BpmnPropertiesProviderModule,
  } from "bpmn-js-properties-panel";
  import EmbeddedComments from "bpmn-js-embedded-comments";
  import download from "downloadjs";
  import { fly } from "svelte/transition";

  import { onMount, onDestroy } from "svelte";

  import { Modal } from "carbon-components-svelte";

  import { fetchWithSession } from "lib/util/fetchWithSession.js";

  import IconButton from "lib/components/IconButton.svelte";

  export let folderid;
  export let expandTreeSideBar;
  export let saveAction;
  export let uploadAction;
  export let downloadAction;

  let foldername = "";
  let modelerCanvas;
  let propertydiv;
  let bpmnuploader;

  let deleteFolderModal = false;
  let clearBPLSModal = false;

  let modeler;
  let emptyxml = `<?xml version="1.0" encoding="UTF-8"?><landscape:Definitions xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:dc="http://www.omg.org/spec/DD/20100524/DC" id="sample-diagram"> <landscape:landscapeBoard id="Board_1" name=""></landscape:landscapeBoard> <landscapeDi:landscapeRootBoard id="RootBoard_1"> <landscapeDi:landscapePlane id="PositPlane_1" boardElement="Board_1"> </landscapeDi:landscapePlane> </landscapeDi:landscapeRootBoard></landscape:Definitions>`;

  onDestroy(() => {
    document.removeEventListener("keydown", checkCtrlS, false);
  });

  onMount(() => {
    document.addEventListener("keydown", checkCtrlS, false);

    modeler = new landscapeModeler({
      container: modelerCanvas,
      keyboard: {
        bindTo: window,
        propertiesPanel: {
          parent: propertydiv,
        },
        additionalModules: [
          BpmnPropertiesPanelModule,
          BpmnPropertiesProviderModule,
          EmbeddedComments,
        ],
      },
    });

    modeler.importXML(emptyxml).catch(function (err) {
      if (err) {
        return console.error("could not import landscape board", err);
      }
    });

    getProcessLandscape();
  });

  // $: {
  //   if (folderid) {
  //     getProcessLandscape();
  //   }
  // }

  // $:{
  //     if(folderid){
  //     getProcessLandscape()
  //     }
  // }

  uploadAction = function uploadLandscape() {
    bpmnuploader.click();
  };

  downloadAction = function exportLandscape() {
    modeler.saveXML({ format: true }).then((result) => {
      download(result.xml, "processlandscape.bpls", "text/plain");
    });
  };

  function getProcessLandscape() {
    fetchWithSession(`/api/pman/getProcessFolder/${folderid}`, {
      method: "GET",
    })
      .then((response) => response.json())
      .then((res) => {
        modeler.importXML(res.landscapestring);
      });
  }

  saveAction = async function saveProcessFolder() {
    var result = await modeler.saveXML({ format: true });
    fetchWithSession(`/api/pman/saveProcessFolder`, {
      method: "POST",
      body: JSON.stringify({
        landscapestring: result.xml,
        id: folderid,
      }),
    })
  };

  function clearBPLS() {
    modeler.importXML(emptyxml.replace('name=""', `name="${foldername}"`));
    clearBPLSModal = false;
  }

  function deleteProcessFolder() {
    fetchWithSession(`/api/pman/deleteProcessFolder`, {
      method: "POST",
      body: JSON.stringify({
        id: folderid,
      }),
    })
      .then((response) => response.json())
      .then((res) => {
        window.location.href = "/app/pman";
      });
  }

  function checkCtrlS(e) {
    if (
      (window.navigator.platform.match("Mac") ? e.metaKey : e.ctrlKey) &&
      e.keyCode == 83
    ) {
      saveProcessFolder();
      e.preventDefault();
    }
  }

  function handleBPLSModel(e) {
    var reader = new FileReader();
    reader.onload = function (event) {
      modeler.importXML(event.target.result);
    };
    reader.readAsText(bpmnuploader.files[0]);
  }
</script>


<div
  style="background:#f2f2f2"
  on:keydown={(e) => {
    checkCtrlS(e);
  }}
>
  <div class="bpmn_modeler_menu">
    <IconButton
      on:click={() => {
        bpmnuploader.click();
      }}
      altText="Upload Model"
      svgPath="/img/ui_icons/upload.svg"
    />
    <!-- <IconButton
      on:click={exportLandscape}
      altText="Download Model"
      svgPath="/img/ui_icons/download.svg"
    /> -->
    <!-- <IconButton
      on:click={saveProcessFolder}
      altText="Save Model"
      svgPath="/img/ui_icons/save.svg"
    /> -->

    <IconButton
      on:click={() => {
        clearBPLSModal = true;
      }}
      color="red"
      altText="Clear Model"
      svgPath="/img/ui_icons/reset.svg"
    />
    <IconButton
      on:click={() => {
        deleteFolderModal = true;
      }}
      color="red"
      altText="Delete Model"
      svgPath="/img/ui_icons/reset.svg"
    />
    <input
      type="file"
      accept=".bpls"
      on:change={handleBPLSModel}
      bind:this={bpmnuploader}
      style="display:none"
    />
  </div>
  <div
    bind:this={modelerCanvas}
    style="margin-top:10px;margin-left:15px;border-radius:5px;background:white; height:calc(100vh - 134px); width:{expandTreeSideBar
      ? '80.5%'
      : '77.4%'}; display:inline-block"
  />
  <!-- <div
    bind:this={propertydiv}
    style="margin-top:10px;border-radius:5px; height:calc(100vh - 110px);background:white; width:300px;  display:inline-block; vertical-align:top"
  /> -->
</div>

<Modal
  size="lg"
  kind="danger"
  open={clearBPLSModal}
  modalHeading="Clear Process Landscape?"
  primaryButtonText="Delete"
  secondaryButtonText="Cancel"
  on:click:button--secondary={() => {
    clearBPLSModal = false;
  }}
  on:open
  on:close={() => {
    clearBPLSModal = false;
  }}
  on:submit={clearBPLS}
>
  Warning: This will clear all parent and child processes!
  <br />
  This will take effect once the process model is saved.
</Modal>

<Modal
  size="lg"
  kind="danger"
  open={deleteFolderModal}
  modalHeading="Delete Process Folder?"
  primaryButtonText="Delete"
  secondaryButtonText="Cancel"
  on:click:button--secondary={() => {
    deleteFolderModal = false;
  }}
  on:open
  on:close={() => {
    deleteFolderModal = false;
  }}
  on:submit={deleteProcessFolder}
>
  Warning: This will also delete all sub folders and processes!
</Modal>

<style>
  .bpmn_modeler_menu {
    display: flex;
    justify-content: space-between;
    position: absolute;
    margin-left: 85px;
    top: calc(100vh - 160px);
    z-index: 99;
    gap: 1rem;
    display: none;
  }
</style>
